import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useBooking(bookingCode: string) {
  const key = useMemo(
    () => [CORE_QUERY_KEYS.booking, { code: bookingCode }],
    [bookingCode]
  );

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getBooking,
        params: { bookingCode },
      }) as Promise<BookingResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
